<template>
  <v-navigation-drawer floating
                       class="elevation-1 rounded flex-shrink-0 mr-3">
    <div class="pa-2">
      <v-list dense
              nav
              class="mt-2 pa-0">
        <v-list-item v-for="contact in contacts"
                     :key="contact.id"
                     :to="{name: 'admin.nylas.contact.show', params:{contactID: contact.id}}">
          <v-list-item-icon
            class="mr-2">
            <v-avatar color="primary"
                      size="32">
              <span class="white--text">{{ contact.initials }}</span>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ contact.name }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="contact.emails.length"
                                  class="d-flex">
              <div>
                {{ contact.emails[0].email }}
              </div>
              <div v-if="contact.emails.length > 1"
                   class="ml-1">
                +{{ contact.emails.length - 1 }}
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </div>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: {
    contacts: {
      type: Array,
      required: true,
    }
  }
}
</script>
